// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  envName: 'DEVELOP',
  PASS_URL: 'https://dev2.pass.ck1lab.net',
  API_TOKEN_URL: 'https://api.dev2.token.ck1lab.net',
  CLIENT_API: 'https://api.dev.careposi-console.ck1lab.net/',
  REFRESH_TOKEN: '',
  SAUCER_LOG_URL: 'https://dev.saucerlog.ck1lab.net/login',
};
// comment test deploy  cicd
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
